import { render } from "./BlockComponent.vue?vue&type=template&id=20a653f0"
import script from "./BlockComponent.vue?vue&type=script&lang=js"
export * from "./BlockComponent.vue?vue&type=script&lang=js"

import "./BlockComponent.vue?vue&type=style&index=0&id=20a653f0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__